// extracted by mini-css-extract-plugin
export default {"divider":"fUhVZ7UP_SP2yYSN0ftD"};